// Sports & Playing Levels stores Golf with positive values denoting plus handicaps.
export function formatPlayingLevel(value, sport, locale = 'en-GB') {
  if (value == null || String(value).trim() === '') return null
  const number = Number(value)
  if (!Number.isFinite(number)) return null
  const formatted = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 2 }).format(sport === 'golf' ? Math.abs(number) : number)
  return sport === 'golf' && number > 0 ? `+${formatted}` : formatted
}

export function playingRangeLabel({ min, max, sport, locale, t }) {
  const lower = formatPlayingLevel(min, sport, locale)
  const upper = formatPlayingLevel(max, sport, locale)
  const metric = t(`portalPresentation.${sport === 'golf' ? 'member_handicap_metric' : 'member_level_metric'}`)
  const isBlank = value => value == null || String(value).trim() === ''
  if ((!isBlank(min) && lower == null) || (!isBlank(max) && upper == null)) return t('portalPresentation.member_level_not_provided')
  if (isBlank(min) && isBlank(max)) return t(sport === 'golf' ? 'portalPresentation.member_all_handicaps' : 'portalPresentation.member_all_levels')
  if (sport === 'golf' && (lower == null || upper == null)) return t(lower != null ? 'portalPresentation.member_handicap_or_better' : 'portalPresentation.member_handicap_or_worse', { value: lower ?? upper })
  return `${metric} ${lower != null && upper != null ? `${lower}–${upper}` : lower != null ? `≥ ${lower}` : `≤ ${upper}`}`
}
